import Vue from 'vue';
import PaymentConsts from '../constants/payments';

export const humanizeSnakeCase = (value?:string):string => {
  if (value == null || value == undefined) return ''
  return value.split("_").join(" ");
}

export const humanizeTemplateName = (value?:string):string => {
  if (!value) return '';
  return value.split('-')[0]
}

export const capitalize = (value?:string):string => {
  if (value == null || value == undefined) return ''
  value = value.toString()
  return value.charAt(0).toUpperCase() + value.slice(1)
}

export const humanizePaymentMethod = (value?:string[]):string => {
  if (!value || !value.length) return '';
  let hasCard = false;
  let hasACH = false;
  value.forEach(pmt => {
    switch (pmt) {
      case PaymentConsts.paymentMethodTypes.ACH:
        hasACH = true;
        break;
      case PaymentConsts.paymentMethodTypes.CARD:
        hasCard = true;
        break;
    }
  })
  if (hasCard && hasACH) {
    return 'Either';
  } else if (hasCard) {
    return 'Credit Card';
  } else if (hasACH) {
    return 'ACH';
  }
  return '';
}

export function AddFilters(app: Vue.App) {
  app.config.globalProperties.$filters = {
    ...app.config.globalProperties.$filters,
    humanizeSnakeCase,
    humanizeTemplateName,
    capitalize,
    humanizePaymentMethod
  }
}
